export const REPORTS_NAMESPACE_TRANSLATIONS = {
  generateReport: {
    title: "Generate Reports",
    description:
      "Generate reports about farm animals with information related to breed, species, sex and their relevant data.",
    note: "Reports will be available in the Reports section after generation, this may take up to 15 seconds.",
    pending: "Generating report...",
    success: "Report generated successfully!",
    error: "Error generating report. Please try again.",
    button: "Generate Animal Report",
    buttonGenerating: "Generating...",
  },

  individualAnimalReports: {
    title: "Individual Animal Reports",
    description:
      "Generate detailed reports about an animal, reproduction, health and productivity.",
    note: "Reports will be available below after generation, this may take up to 15 seconds.",
    button: "Generate animal report",
  },

  filters: {
    all: "All Reports",
    animal: "Animal Reports",
    financial: "Financial Reports",
    production: "Production Reports",
  },

  status: {
    pending: "Pending",
    processing: "Processing",
    completed: "Completed",
    failed: "Failed",
  },
}
